module.exports = "mutation ValidatePhoneNumber($phoneNumber: PhoneNumberInput!) {\n  validatePhoneNumber(phoneNumber: $phoneNumber) {\n    isValid\n  }\n}\n"